module.exports = "<div class=\"js-loading-region\"></div>\n<div class=\"form-class\"></div>\n";